import "../../styles/materialize.css";

function formatXML(xml) {
  if (!xml) return "";

  const PADDING = "  ";
  const reg = /(>)(<)(\/*)/g;
  let formatted = "";
  let pad = 0;

  xml
    .replace(reg, "$1\n$2$3")
    .split("\n")
    .forEach(line => {
      let indent = 0;

      // closing tag → reduce indent
      if (/^<\/\w/.test(line)) {
        pad = Math.max(pad - 1, 0);
      }
      // opening tag (not self-closing)
      else if (
        /^<\w/.test(line) &&
        !/\/>$/.test(line)
      ) {
        indent = 1;
      }

      formatted += PADDING.repeat(pad) + line + "\n";
      pad += indent;
    });

  return formatted.trim();
}

export default function CampaignPreviewModal({
  open,
  onClose,
  data,
  prompt_text
}) {
  if (!open) return null;

  const xml = data?.workflow_xml || "";
  const formattedXML = formatXML(xml);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(xml);
      alert("Workflow XML copied to clipboard");
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  const saveAsFile = (ext) => {
    if (!xml) return;

    const blob = new Blob([xml], { type: "text/xml;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${(data?.workflow_name || "workflow").toLowerCase().replace(/\s+/g, "_")}.${ext}`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="modal-backdrop">
      <div className="modal full">
        <div className="modal-header">
          <h3>Campaign Preview</h3>

          <div style={{ display: "flex", gap: "8px" }}>
            <button
              className="admin-btn secondary"
              onClick={copyToClipboard}
            >
              Copy XML
            </button>

            <button
              className="admin-btn secondary"
              onClick={() => saveAsFile("yxmd")}
            >
              Save as File
            </button>

            {/* <button
              className="admin-btn secondary"
              onClick={() => saveAsFile("yxwz")}
            >
              Save as .yxwz
            </button> */}

            <button
              className="admin-btn danger"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>

        <div className="modal-body">
          {/* PROMPT TEXT */}
          {prompt_text && (
            <div className="prompt-box">
              <strong>Prompt:</strong> {prompt_text}
            </div>
          )}

          {/* XML PREVIEW */}
          <pre className="xml-preview">
            {formattedXML}
          </pre>
        </div>
      </div>
    </div>
  );
}
